/*!
=========================================================
* キャンセル申請一覧
=========================================================
*/
import React from "react";

import {
  Button,
  Col,
  Label,
} from "reactstrap";

import Request from '../../common/Request';
import DialogBase from '../Base/DialogBase';
import ListBase from '../Base/ListBase';
import InputText from '../FormParts/InputText'
import InputDatetime from '../FormParts/InputDatetime'
import Definition from '../../common/Definition';
import OptionConvert from '../../common/OptionConvert';
import InputSelect from '../FormParts/InputSelect';
import WithRole from '../FormParts/ButtonWithRole';
import { GetMessage, getErrorCodes } from "../../variables/message";
import InputCheckBox from '../FormParts/InputCheckBox'
import {
  cst_estimate_cancel_status
} from '../../variables/codes_map';
import FormatCode from '../../common/FormatCode';

class List extends ListBase {
  default_column = [
    { Header: '見積ID',accessor: 'ESTIMATE__estimate_number',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50,defaultView:true},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,defaultView:true},
    { Header: '顧客情報（下請）',accessor: '___JOIN_subcontract_customer_information',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,defaultView:true},
    { Header: '現場名/工事番号',accessor: '___JOIN_project_information_estimate',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true},
    { Header: '現場住所',accessor: '___JOIN_project_addr',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '仕入先情報',accessor: '___JOIN_quote_use_parking',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50,defaultView:true},
    { Header: '契約期間',accessor: '___JOIN_quote_available_date',headerClassName:'text-center',className:'text-left text-top',width:190,minWidth:50,defaultView:true},
    { Header: '申請ステータス',accessor: 'ESTIMATE__estimate_cancel_status',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true, sortable : false},
    { Header: '申請理由',accessor: 'ESTIMATE__estimate_cancel_memo',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,defaultView:true},
    { Header: '承認',accessor: 'approveAction',headerClassName:'text-center',className:'text-center text-top',width:100,minWidth:50,defaultView:true, sortable : false},
    { Header: '否認',accessor: 'disapproveAction',headerClassName:'text-center',className:'text-center text-top',width:100,minWidth:50,defaultView:true, sortable : false},
    { Header: '申請承認理由',accessor: 'ESTIMATE__estimate_cancel_approval_memo',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,defaultView:true},
    { Header: '申請否認理由',accessor: 'ESTIMATE__estimate_cancel_return_memo',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,defaultView:true},
    { Header: '最終更新情報', accessor: '___JOIN_estimate_update', headerClassName: "text-center", className: "text-left text-top" ,width:225,defaultView:true},
  ];
  
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: 'キャンセル申請一覧',
      add_url: '',
      search_url: '/api/cancel',
      column: this.default_column,
      detail_search:false,
      valid: true,
      searchData:{
        values:{
          estimate_cancel_status : ["1"]
        },
        errors:{},
        requiredData:{}
      },
      dialogData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      landmark_user:[],
      user_list_for_lastupdate:[]
    });
    this.dialogEstimateCancel = React.createRef();
    this.search = this.search.bind(this)

    this.validateCallback = this.validateCallback.bind(this)
    this.setPropsForDialog = this.setPropsForDialog.bind(this)
    this.getLastUpdaedUser = this.getLastUpdaedUser.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      console.log('user',res.Data);
      const user_list_for_lastupdate = OptionConvert.optionsById(res.Data)
      const user_list = res.Data.map((user)=>{
        return {value:user.id, label:user.name}
      })
      this.setState({
        landmark_user:user_list,
        user_list_for_lastupdate
      }, () => {
        this.search(false);
      });
    })
  }

  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.user_list_for_lastupdate;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }

  dataMap(data) {
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}
      return {
        id: key,
        ESTIMATE__estimate_number: (<a href={`https://drive.google.com/open?id=${prop.latest_pdf_survey_url}`} target="_blank">{prop.estimate_natural_id}</a>),
        ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
        ___JOIN_subcontract_customer_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />,
        ___JOIN_project_information_estimate: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information_estimate', prop)}} />,
        ___JOIN_project_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_addr', prop)}} />,
        ___JOIN_quote_use_parking: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_use_parking', prop)}} />,
        ___JOIN_quote_available_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_available_date', prop)}} />,
        ESTIMATE__estimate_cancel_status : FormatCode.decode("cst_estimate_cancel_status", prop.estimate_cancel_status),
        ESTIMATE__estimate_cancel_memo: prop.estimate_cancel_memo,
        approveAction : 
        <>
          <ButtonWithRole 
            // button_id="BTN_F1_04_02695" 
            size="sm" 
            className="text-center" 
            onClick={()=>{this.setPropsForDialog(prop, 2); this.dialogEstimateCancel.current.show()}} 
            disabled={prop.estimate_cancel_status != 1}
          >
              承認
          </ButtonWithRole>
        </>,
        disapproveAction : 
        <>
          <ButtonWithRole 
            // button_id="BTN_F1_04_02695" 
            size="sm" 
            className="text-center" 
            onClick={()=>{this.setPropsForDialog(prop, 3); this.dialogEstimateCancel.current.show()}} 
            disabled={prop.estimate_cancel_status != 1}
          >
              否認
          </ButtonWithRole>
        </>,
        ESTIMATE__estimate_cancel_approval_memo : prop.estimate_cancel_approval_memo,
        ESTIMATE__estimate_cancel_return_memo : prop.estimate_cancel_return_memo,
        ___JOIN_estimate_update: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_estimate_update', prop_tmp)}} />,
      }
    });
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true) {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    Request.get(this.state.search_url, 
      this.search_params()
      , res => {
        
        this.setState({
            data: this.dataMap(res.Data)
        });
      
    })
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  search_field_cols() {
    return (
      <>
        <Col md="4">
          <InputText
            label='案件ID'
            name='ESTIMATE__request_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="4">
          <InputText
            label='見積ID'
            name='ESTIMATE__estimate_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="4">
          <InputCheckBox
            label='キャンセル申請ステータス'
            name='ESTIMATE__estimate_cancel_status'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_estimate_cancel_status}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>
    );
  }
  add_field_cols() {
    return (<></>);
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<>
        <Col md="6">
          <InputSelect
            label="調査担当者"
            name="REQUEST__onsite_survey_account"
            labelOn={true}
            options={this.state.landmark_user}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            isSearchable={true}
            validateType={'search'}
          />
        </Col>
        <Col md="6">
          <InputDatetime
            label='見積提出期限（FROM）'
            name='REQUEST__estimate_deadline_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="6">
          <InputDatetime
            label='見積提出期限（TO）'
            name='REQUEST__estimate_deadline_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>);
  }
  
  setPropsForDialog(props, estimate_cancel_status){
    this.setState({
      dialogData:{
        values: {
          ...props,
          estimate_cancel_status
        },
        errors:{},
        requiredData:{}
      }
    })
  }

  dialog_defines() {
    return (
      <>
        <DialogEstimateCancel 
          ref={this.dialogEstimateCancel} 
          data={this.state.dialogData}
          positive={true}
          refreshCallback={()=>{this.search(true)}}
          {...this.props}
        />
      </>
    );
  }
}

export class DialogEstimateCancel extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      data: this.props.data
    });
    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      const title = this.props.data.values.estimate_cancel_status === 2 ? "承認" : "否認"
      this.setState({
        title: `見積キャンセル申請を${title}します。よろしいですか？`,
        data:this.props.data
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:newData
    }, ()=>callback())
  }

  handleClickPositive() {
    const update_estimate_status = this.props.data.values.estimate_cancel_status === 2 ? 8 : this.state.data.values.estimate_status;
    const params = {
      ...this.state.data.values,
      estimate_status : update_estimate_status
    }

    Request.put(`/api/cancel/${this.state.data.values.ulid}`, params,
      (res)=>{
        this.props.refreshCallback()
        this.toggleModal();
    })
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(
    <>
      {this.props.data.values.estimate_cancel_status === 2 ?
        <InputText 
          multiline={true}
          labelOn={true}
          label='見積キャンセル申請承認理由'
          name='ESTIMATE__estimate_cancel_approval_memo'
          copy="false"
          validateCallback={this.validateCallback} 
          rootData={this.state.data}
          validateType='regist'
        />
      :
        <InputText 
            multiline={true}
            labelOn={true}
            label='見積キャンセル申請否認理由'
            name='ESTIMATE__estimate_cancel_return_memo'
            copy="false"
            validateCallback={this.validateCallback} 
            rootData={this.state.data}
            validateType='regist'
          />
      }
    </>);
  }
}

export default List;
